import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { FormControl, Box, Typography, MenuItem, Select, FormLabel, InputLabel } from '@mui/material';
import { Modal } from '../components/BootstrapToMUI';
import Swal from 'sweetalert2';
import request from '../services/Request';
import { useTheme } from '@mui/material/styles';
import { useForm, Controller } from 'react-hook-form';

export default function CreatePlanoModal(props) {
  const theme = useTheme();
  const { id, reflesh, setReflesh, machines, modelsToCheck, theModel, MagexModel, ...rest } = props;

  const CreatePlanoURL = `/plano/create`;
  const CreateTCNPlanoURL = `/TCNplano/create`;

  const defaultValues = {
    name: '',
    model: '',
    floorNumber: 6,
  };

  const {
    reset,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  const selectedModel = watch('model');

  // Build lookup array from machines
  const lookup = [
    ...new Set(
      machines.map((e) => {
        if (modelsToCheck.some((model) => e.model.includes(model))) {
          return e.model;
        } else {
          if (e.stock == 1)
            return `${e.model} (${e.lane.toString()} Lanes, ${e.floor.toString()} Floors)`;
          else {
            if (e.modelNum) {
              return `${e.model} (${e.modelNum} Stocks)` + ` + ${e.model1} (${e.modelNum1} Stocks)`;
            } else {
              return `${e.model} (${e.lane.toString()} Lanes, ${e.floor.toString()} Floors * ${
                e.stock
              } Stocks)`;
            }
          }
        }
      })
    ),
  ];

  const onSubmit = async (newData) => {
    const index = lookup[newData.model].indexOf('(');
    const modelName =
      index > -1 ? lookup[newData.model].substring(0, index).trim() : lookup[newData.model];

    let mIndex = -1;
    if (lookup[newData.model].includes('+')) {
      mIndex = machines.findIndex(
        (e) =>
          `${e.model} (${e.modelNum} Stocks)` + ` + ${e.model1} (${e.modelNum1} Stocks)` ===
          lookup[newData.model]
      );
    } else {
      if (modelsToCheck.some((model) => modelName.includes(model))) {
        mIndex = machines.findIndex((e) => e.model == modelName);
      } else {
        const floor = lookup[newData.model].split(',')[1][1];
        mIndex = machines.findIndex((e) => e.model == modelName && e.floor == floor);
      }
    }

    try {
      if (modelsToCheck.some((model) => modelName.includes(model))) {
        const findIndex = theModel.findIndex((e) => e.name === lookup[newData.model]);
        if (findIndex > -1) {
          let stockNum = null;
          let name1 = newData.name;
          let name2 = newData.name;
          let stock = 1;
          if (modelName.includes('SmartBox')) {
            stockNum = 1;
            name1 = `${newData.name} (Stock 1)`;
            name2 = `${newData.name} (Stock 2)`;
            stock = 2;
          }
          await request({
            method: 'post',
            url: CreateTCNPlanoURL,
            data: {
              name: name1,
              lineNumber: machines[mIndex].lane,
              floorNumber: newData.floorNumber,
              referTo: id,
              model: lookup[newData.model],
              laneLength: machines[mIndex].laneLength,
              slot_height: machines[mIndex].slot_height,
              step_depth: machines[mIndex].step_depth,
              step_num: machines[mIndex].step_num,
              height: theModel[findIndex].height,
              width: theModel[findIndex].width,
              depth: theModel[findIndex].depth,
              divider: theModel[findIndex].divider,
              min_width: theModel[findIndex].min_width,
              min_height: theModel[findIndex].min_height,
              stockNum: stockNum,
              stock: stock,
            },
          }).then((res) => {
            if (modelName.includes('SmartBox')) {
              request({
                method: 'post',
                url: CreateTCNPlanoURL,
                data: {
                  name: name2,
                  lineNumber: machines[mIndex].lane,
                  floorNumber: newData.floorNumber,
                  referTo: id,
                  referPlano: res.data.plano._id,
                  model: lookup[newData.model],
                  laneLength: machines[mIndex].laneLength,
                  slot_height: machines[mIndex].slot_height,
                  step_depth: machines[mIndex].step_depth,
                  step_num: machines[mIndex].step_num,
                  height: theModel[findIndex].height,
                  width: theModel[findIndex].width,
                  depth: theModel[findIndex].depth,
                  divider: theModel[findIndex].divider,
                  min_width: theModel[findIndex].min_width,
                  min_height: theModel[findIndex].min_height,
                  stockNum: 2,
                  stock: 2,
                },
              }).then((res) => {
                setReflesh(!reflesh);
              });
            } else {
              setReflesh(!reflesh);
            }
          });
        }
      } else {
        if (!lookup[newData.model].includes(' Stocks')) {
          await request({
            method: 'post',
            url: CreatePlanoURL,
            data: {
              name: newData.name,
              lineNumber: machines[mIndex].lane,
              floorNumber: machines[mIndex].floor,
              referTo: id,
              model: lookup[newData.model],
              laneLength: machines[mIndex].laneLength,
              slot_height: machines[mIndex].slot_height,
              step_depth: machines[mIndex].step_depth,
              step_num: machines[mIndex].step_num,
              height: machines[mIndex].height,
            },
          }).then((res) => {
            setReflesh(!reflesh);
          });
        } else {
          await request({
            method: 'post',
            url: CreatePlanoURL,
            data: {
              name: `${newData.name} (${machines[mIndex].stock} Stocks -- Stock 1)`,
              lineNumber: machines[mIndex].lane,
              floorNumber: machines[mIndex].floor,
              referTo: id,
              model: machines[mIndex].model,
              stock: machines[mIndex].stock,
              stockNum: 1,
              laneLength: machines[mIndex].laneLength,
              slot_height: machines[mIndex].slot_height,
              step_depth: machines[mIndex].step_depth,
              step_num: machines[mIndex].step_num,
              height: machines[mIndex].height,
            },
          }).then(async (res) => {
            if (!machines[mIndex].modelNum) {
              for (var i = 1; i < machines[mIndex].stock; i++) {
                await request({
                  method: 'post',
                  url: CreatePlanoURL,
                  data: {
                    name: `${newData.name} (${machines[mIndex].stock} Stocks -- stock ${i + 1})`,
                    lineNumber: machines[mIndex].lane,
                    floorNumber: machines[mIndex].floor,
                    referTo: id,
                    stock: machines[mIndex].stock,
                    stockNum: i + 1,
                    model: lookup[newData.model],
                    referPlano: res.data.plano._id,
                    laneLength: machines[mIndex].laneLength,
                    slot_height: machines[mIndex].slot_height,
                    step_depth: machines[mIndex].step_depth,
                    step_num: machines[mIndex].step_num,
                    height: machines[mIndex].height,
                  },
                }).then((res) => {
                  setReflesh(!reflesh);
                });
              }
            } else {
              await request({
                method: 'post',
                url: CreatePlanoURL,
                data: {
                  name: `${newData.name} (${machines[mIndex].stock} Stocks -- stock 2)`,
                  lineNumber: machines[mIndex].lane1,
                  floorNumber: machines[mIndex].floor1,
                  referTo: id,
                  stock: machines[mIndex].stock,
                  stockNum: 2,
                  model: lookup[newData.model],
                  referPlano: res.data.plano._id,
                  laneLength: machines[mIndex].laneLength1,
                  slot_height: machines[mIndex].slot_height1,
                  step_depth: machines[mIndex].step_depth1,
                  step_num: machines[mIndex].step_num1,
                  height: machines[mIndex].height1,
                },
              }).then((res) => {
                setReflesh(!reflesh);
              });
            }
          });
        }
      }

      props.onHide();
      reset();
      Swal.fire({
        text: `New planogram has been successfully created: ${newData.name}`,
        icon: 'success',
      });
    } catch (error) {
      Swal.fire({
        text: error.response?.data?.message || 'Failed to create planogram',
        icon: 'error',
      });
    }
  };

  return (
    <Modal className="modal-w" {...rest} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" sx={{ fontSize: '1.1rem', fontWeight: 600 }}>
          Create Planogram
        </Modal.Title>
      </Modal.Header>
      <Modal.Body sx={{ px: 5, py: 4 }}>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
          {/* Planogram Name */}
          <Box sx={{ mb: 4 }}>
            <Controller
              name="name"
              control={control}
              rules={{ required: 'Planogram name is required' }}
              render={({ field: { onChange, value } }) => (
                <TextField
                  label="Planogram Name"
                  variant="outlined"
                  required
                  fullWidth
                  size="small"
                  onChange={onChange}
                  value={value}
                  error={!!errors.name}
                  helperText={errors.name?.message}
                />
              )}
            />
          </Box>

          {/* Model Selection */}
          <Box sx={{ mb: 4 }}>
            <Controller
              name="model"
              control={control}
              rules={{ required: 'Model is required' }}
              render={({ field: { onChange, value } }) => (
                <FormControl fullWidth size="small" error={!!errors.model}>
                  <InputLabel>Model *</InputLabel>
                  <Select label="Model *" onChange={onChange} value={value}>
                    {lookup.map((item, index) => (
                      <MenuItem key={index} value={index}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.model && (
                    <Typography color="error" variant="caption" sx={{ mt: 0.5, ml: 1.5 }}>
                      {errors.model.message}
                    </Typography>
                  )}
                </FormControl>
              )}
            />
          </Box>

          {/* Floor Number */}
          {selectedModel !== '' &&
            modelsToCheck.some((model) => lookup[selectedModel]?.includes(model)) && (
              <Box sx={{ mb: 4 }}>
                <Controller
                  name="floorNumber"
                  control={control}
                  rules={{
                    required: 'Floor number is required',
                    min: { value: 1, message: 'Floor number must be at least 1' },
                  }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="Number of Floors"
                      variant="outlined"
                      required
                      fullWidth
                      size="small"
                      type="number"
                      onChange={onChange}
                      value={value}
                      error={!!errors.floorNumber}
                      helperText={errors.floorNumber?.message}
                    />
                  )}
                />
              </Box>
            )}

          {/* Submit Button */}
          <Box sx={{ mt: 5, display: 'flex', justifyContent: 'center' }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                minWidth: 180,
                py: 1.2,
                fontSize: '0.95rem',
                fontWeight: 600,
                textTransform: 'none',
              }}
            >
              Create Planogram
            </Button>
          </Box>
        </Box>
      </Modal.Body>
    </Modal>
  );
}
